import React from 'react'
import { Modal } from 'react-bootstrap'

const LoadingModal = (props) => {
  return (
    <Modal show={props.show} style={{top: '25%'}}>
      <Modal.Body>
        <center>
          <img alt="loader" src={require("../static/images/spinner.gif")} />
          <h4>{props.text}</h4>
        </center>
      </Modal.Body>
    </Modal>
  )
}

export default LoadingModal



// WEBPACK FOOTER //
// ./src/reuseable-components/LoadingModal.js